module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/facebook-black-dabd6bec8dc2c97b43d196e7f16a7fa4.svg";